module.exports = __webpack_public_path__ + "img/setting-out.9402047f.jpg";